const normalizeEntityArray = <Entity extends { id: string }>(array: Array<Entity>, field: keyof Entity = 'id') => {
  return array.reduce(
    (entitiesById, entity) => ({
      ...entitiesById,
      [`${entity[field]}`]: entity,
    }),
    {} as Record<string, Entity>,
  );
};

export default normalizeEntityArray;
